<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.unitId" hidden/>

      <t-input v-model="form.name"  :add-error="error.name" label="Un. Medida" required/>

      <t-input v-model="form.description" :add-error="error.description" label="Descrição" required/>

      <t-input v-model="form.quantityUnit" number label="Quantidade individual" help="Por padrão será 1 item, porém para unidades como por exemplo: Duzia deverá inserir 12. Este campo será utilizado em componentes e matéria-prima" required/>

      <b-form-checkbox class="col-sm-12" v-model="form.integerType" switch>
        Esta unidade de medida utiliza números inteiros?
        <t-help
            title="Desmarque para escolhar a quantidade de decimais, caso desejar."/>
      </b-form-checkbox>

      <t-input class="mt-2" v-show="!form.integerType" label="Qtd. de casas decimais" help="Quantidade de casas decimais que será aplicada ao selecionar esta unidade de medida."
               v-model="form.decimalPrecision" :options="decimalPrecisionOptions"
               radio :required="!form.integerType"/>

      <t-input class="mt-2" v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'UnitForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "unitId",
      form: {
        unitId: 0,
        integerType:true,
        decimalPrecision:0,
        quantityUnit:1,
        name: "",
        description: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        description:"",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      decimalPrecisionOptions: [
        {value: 1, text: "0,0"},
        {value: 2, text: "0,00"},
        {value: 3, text: "0,000"},
        {value: 4, text: "0,0000"},
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
